import axios from "axios";

let getSelectList = async function(dictData){
  if(dictData==null){
    return null;
  }
  const url = "/stage-api/web/dictionary/queryDictRows?params="+dictData;
  const result = await axios.get(url);
  return result.data;
}
export default {  getSelectList }
